<template>
  <transition appear name="fade" mode="in-out">
    <div v-show="show" class="fixed inset-0 z-10 flex flex-col justify-start items-end mt-90px">
      <transition appear name="fade" mode="in-out">
        <div
          v-show="show && overlay"
          @click="$emit('closeDropdown')"
          class="absolute inset-0 z-0 bg-beta opacity-70 cursor-pointer"
          :title="$t('closeLaunchpad')"></div>
      </transition>
      <transition appear name="slideVerticalFade" mode="in-out">
        <main v-show="show" class="TopBlip text-beta bg-alpha border-grey-darkest text-center relative z-10 w-full max-w-4xl mr-8px p-24px md:p-32px lg:px-40px shadow-md rounded-lg">
          <slot></slot>
        </main>
      </transition>
    </div>
  </transition>
</template>

<script>
import i18n from '../../i18n';

export default {
  i18n,
  name: 'Dropdown',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    overlay: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="postcss">
@tailwind base;
@tailwind components;
@tailwind utilities;
/*! purgecss start ignore */
.TopBlip {
  margin-top: -3px;

  &::before {
    @apply absolute z-20 block;

    content: '';
    width: 0;
    height: 0;
    top: -10px;
    right: 32px;
    border-right: 11px solid transparent;
    border-bottom: 11px solid var(--color-alpha);
    border-left: 11px solid transparent;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .15s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slideVerticalFade-enter-active, .slideVerticalFade-leave-active {
  transition: opacity .15s ease-out, transform .15s ease-out;
}

.slideVerticalFade-enter, .slideVerticalFade-leave-to {
  opacity: 0;
  transform: translateY(36px);
}

.slideHorizontalFade-enter-active, .slideHorizontalFade-leave-active {
  transition: opacity 1s ease-out, transform 1s ease-out;
}

.slideHorizontalFade-enter, .slideHorizontalFade-leave-to {
  opacity: 0;
  transform: translateX(36px);
}

.button {
  @apply text-orange;
  @apply font-semibold;
  @apply leading-none;
  @apply uppercase;
  @apply tracking-wide;
  @apply text-center;
  @apply no-underline;
  @apply bg-transparent;

  background:
    /* top */
    linear-gradient(
      to right,
      #e03237 0%,
      #fd8c3c 100%
    )
    left
    top
    no-repeat,
    /* bottom */
    linear-gradient(
      to right,
      #e03237 0%,
      #fd8c3c 100%
    )
    left
    bottom
    no-repeat,
    /* right */
    linear-gradient(
      to top,
      #e03237 0%,
      #e03237 100%
    )
    left
    bottom
    no-repeat,
    /* right */
    linear-gradient(
      to top,
      #fd8c3c 0%,
      #fd8c3c 100%
    )
    right
    bottom
    no-repeat;
  background-size: 100% 2px, 100% 2px, 2px 100%, 2px 100%;
  border: 0;

  &:active {
    transform: scale(.975);
  }

  &:disabled {
    opacity: .5;
    cursor: not-allowed;
  }

  &:hover,
  &:focus {
    @apply text-white;
    background: linear-gradient(to right, theme('colors.red') 0%, theme('colors.orange') 100%);
    box-shadow: 0;
  }
}

.button-alt {
  @apply text-white;
  @apply font-semibold;
  @apply leading-none;
  @apply uppercase;
  @apply tracking-wide;
  @apply text-center;
  @apply no-underline;
  @apply inline-block;
  @apply rounded-sm;

  background: linear-gradient(to right, theme('colors.red') 0%, theme('colors.orange') 100%);
  transition: none;

  &:active {
    transform: scale(.975);
  }

  &:disabled {
    opacity: .5;
    cursor: not-allowed;
  }

  &:hover,
  &:focus {
    @apply bg-transparent;
    @apply text-orange;
    background:
      /* top */
      linear-gradient(
        to right,
        #e03237 0%,
        #fd8c3c 100%
      )
      left
      top
      no-repeat,
      /* bottom */
      linear-gradient(
        to right,
        #e03237 0%,
        #fd8c3c 100%
      )
      left
      bottom
      no-repeat,
      /* right */
      linear-gradient(
        to top,
        #e03237 0%,
        #e03237 100%
      )
      left
      bottom
      no-repeat,
      /* right */
      linear-gradient(
        to top,
        #fd8c3c 0%,
        #fd8c3c 100%
      )
      right
      bottom
      no-repeat;
    background-size: 100% 2px, 100% 2px, 2px 100%, 2px 100%;
    border: 0;
    box-shadow: 0;
  }
}

.button-fine-error {
  @apply underline bg-transparent rounded-sm;

  &:hover,
  &:focus {
    @apply text-white bg-red no-underline;
  }
}

.ActionRequired a,
.ActionRequired button {
  @apply text-14px px-24px py-16px;
}
/*! purgecss end ignore */
</style>
